module.exports = "/_next/static/images/fulfilmentGlobe-95a630918804e0b63a600a9e3e32af6f.png.webp";